import { render, staticRenderFns } from "./rewardCollectEdit_bak.vue?vue&type=template&id=166492c5&scoped=true&"
import script from "./rewardCollectEdit_bak.vue?vue&type=script&lang=js&"
export * from "./rewardCollectEdit_bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166492c5",
  null
  
)

export default component.exports